/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * The generated engagement verification letter, PDF base64-encoded (the standard PDF envelope).
 * @export
 * @interface EngagementLetterResponse
 */
export interface EngagementLetterResponse {
  /**
   *
   * @type {string}
   * @memberof EngagementLetterResponse
   */
  base64EncodedPdf: string;
}

/**
 * Check if a given object implements the EngagementLetterResponse interface.
 */
export function instanceOfEngagementLetterResponse(
  value: object,
): value is EngagementLetterResponse {
  if (!("base64EncodedPdf" in value) || value["base64EncodedPdf"] === undefined)
    return false;
  return true;
}

export function EngagementLetterResponseFromJSON(
  json: any,
): EngagementLetterResponse {
  return EngagementLetterResponseFromJSONTyped(json, false);
}

export function EngagementLetterResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EngagementLetterResponse {
  if (json == null) {
    return json;
  }
  return {
    base64EncodedPdf: json["base64EncodedPdf"],
  };
}

export function EngagementLetterResponseToJSON(
  json: any,
): EngagementLetterResponse {
  return EngagementLetterResponseToJSONTyped(json, false);
}

export function EngagementLetterResponseToJSONTyped(
  value?: EngagementLetterResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    base64EncodedPdf: value["base64EncodedPdf"],
  };
}
